import react from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';


const CategoriesCard = ({ category }) => {
    return (
        <> {/* Category Quick Links */}
      <section className="py-12 lg:py-20 bg-gray-100">
        <div className="container mx-auto pt-2 px-4">
          <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              
              {/* Dresser Mirrors */}
              <Link 
                to="/products?category=dresser-mirrors"
                className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-50 to-primary-100 p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-white rounded-xl shadow-md flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <span className="text-2xl">🗄️</span>
                  </div>
                  <h3 className="text-2xl font-bold text-dark-900 mb-2">Dresser Mirrors</h3>
                  <p className="text-dark-600 mb-4">Dresser mirrors & makeup vanities</p>
                  <div className="flex items-center gap-2 text-primary-700 font-semibold">
                    <span>Shop Now</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-2 transition-transform duration-300" />
                  </div>
                </div>
                <div className="absolute top-0 right-0 w-32 h-32 bg-primary-200 rounded-full -mr-16 -mt-16 opacity-50 group-hover:scale-150 transition-transform duration-500" />
              </Link>
              
              {/* Kitchen Cabinets */}
              <Link 
                to="/products?category=kitchen-cabinets"
                className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-accent-50 to-accent-100 p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-white rounded-xl shadow-md flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <span className="text-2xl">📦</span>
                  </div>
                  <h3 className="text-2xl font-bold text-dark-900 mb-2">Kitchen Cabinets</h3>
                  <p className="text-dark-600 mb-4">Custom kitchen storage solutions</p>
                  <div className="flex items-center gap-2 text-accent-700 font-semibold">
                    <span>Shop Now</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-2 transition-transform duration-300" />
                  </div>
                </div>
                <div className="absolute top-0 right-0 w-32 h-32 bg-accent-200 rounded-full -mr-16 -mt-16 opacity-50 group-hover:scale-150 transition-transform duration-500" />
              </Link>

              {/* Bookshelves */}
              <Link 
                to="/products?category=bookshelves"
                className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-50 to-accent-50 p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="relative z-10">
                  <div className="w-14 h-14 bg-white rounded-xl shadow-md flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <span className="text-2xl">📚</span>
                  </div>
                  <h3 className="text-2xl font-bold text-dark-900 mb-2">Bookshelves</h3>
                  <p className="text-dark-600 mb-4">Stylish display units</p>
                  <div className="flex items-center gap-2 text-primary-700 font-semibold">
                    <span>Shop Now</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-2 transition-transform duration-300" />
                  </div>
                </div>
                <div className="absolute top-0 right-0 w-32 h-32 bg-primary-200 rounded-full -mr-16 -mt-16 opacity-50 group-hover:scale-150 transition-transform duration-500" />
              </Link>
            </div>
          </div>
        </div>
      </section>
        </>
    );
}
export default CategoriesCard;